define('lq/parameterBinding',[],function() {

    var getValue = function(drop, parameterBinding) {
        return drop.piping.parameters.getValue(parameterBinding.name);
    };
    
    var shouldAutoUpdate = function(parameterBinding) {
        return parameterBinding.name
            && parameterBinding.autoUpdate;
    };

    var createUpdateBinding = function(drop, parameterBinding, valueSetter) {
        if (!shouldAutoUpdate(parameterBinding)) return;
        
        var binding = drop.piping.parameters.subscribeForUpdates(
            parameterBinding.name,
            valueSetter,
            false
        );
        drop.registerDisposable(binding);
    };
    
    var initialize = function(drop, parameterBinding, valueSetter) {
        if(!parameterBinding) return;

        var initialValue = getValue(drop, parameterBinding);
        valueSetter(initialValue);

        createUpdateBinding(drop, parameterBinding, valueSetter);
    };

    var initializeUpdates = function(drop, parameterBinding, valueSetter) {
        if(!parameterBinding) return;

        createUpdateBinding(drop, parameterBinding, valueSetter);
    };

    var getParameterName = function(parameterBinding) {
        if(parameterBinding && parameterBinding.name)
            return parameterBinding.name;
        return undefined;
    };    

    return {
        initialize: initialize,
        initializeUpdates: initializeUpdates,
        getValue: getValue,
        getParameterName: getParameterName
    };

});
